
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import Api from '@/core/api';
import IconButton from '@/common/icon-button/IconButton.vue';
import { Icon } from '@/common/icon/Icon.vue';
import { Unsubscriber } from '@/core/event-bus';
import { PlayerState } from '@/core/player-state';

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            isNativeFullScreen: false,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        icon(): Icon {
            return this.isNativeFullScreen ? Icon.minimize : Icon.maximize;
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(
            (partial: Partial<PlayerState>) => {
                this.isNativeFullScreen = get(partial, 'isNativeFullScreen', this.isNativeFullScreen);
            }
        );

        this.isNativeFullScreen = get(state, 'isNativeFullScreen', this.isNativeFullScreen);

        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        toggleFullScreen() {
            if (this.isNativeFullScreen) {
                this.api.exitNativeFullScreen();
            } else {
                this.api.enterNativeFullScreen();
            }
        }
    }
});
